import React from 'react';

const MainSectionContainer = ({component}) => {
  
  return (
    <div className="ui-container" >
      {component}
    </div>
  )
};


export default MainSectionContainer;



